import {makeStyles} from '@material-ui/core';
import Typography from '@material-ui/core/Typography/Typography';
import {memo} from 'react';

type Props = {
  title: string;
  stepDesc: string;
};

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 5,
    paddingBottom: 10,
  },
}));

const FormTitleSeparator = memo(({title, stepDesc}: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography style={{fontWeight: 600}} variant="subtitle1">
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {stepDesc}
      </Typography>
    </div>
  );
});

FormTitleSeparator.displayName = 'FormTitleSeparator';

export default FormTitleSeparator;
